import { DecimalPipe } from '@angular/common';
import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { CurrencyToSymbolPipe } from './currency-to-symbol.pipe';

@Pipe({
  name: 'amountCurrencyDisplay',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class AmountCurrencyDisplayPipe implements PipeTransform {

  private decimalPipe = inject(DecimalPipe);
  private currencyToSymbolPipe = inject(CurrencyToSymbolPipe)

  transform(amount: number, currency: string, divider: number = 1): string {
    if (amount === null || amount === undefined) {
      amount = 0;
    }
    const amountDisplay: string = this.decimalPipe.transform(amount / divider, '1.2-2');
    return amountDisplay + ' ' + this.currencyToSymbolPipe.transform(currency);
  }
}
